import { SkeletonText } from '@carbon/react';

interface Props {
  rows: number;
}

const SkeletonTextRows = ({ rows }: Props) => {
  return (
    <>
      {[...Array(rows)].map((_el, i) => (
        <SkeletonText key={`skeleton-text-${i}`} />
      ))}
    </>
  );
};

export { SkeletonTextRows };
